import React from "react";

import EffectsManager from "../../common/effects/EffectsManager/EffectsManager";
import { TABLE_EVENTS } from "../effects";

export default function EffectsConfig() {
  return <EffectsManager eventOptions={TABLE_EVENTS} />;
}
